import { getEnv, getMockAddress } from "#/utils/getEnv";

export const APPLICATION = {
  ID: process.env.REACT_APP_ID,
  NAME: `@${process.env.REACT_APP_ID.replace("-", "_").toUpperCase()}`,
  get BFF_URL() {
    const env = getEnv();
    if (env === "mock" || !window.env) {
      return getMockAddress();
    }

    return window.env.BFF_URL;
  },

  get ENV() {
    return window.env.ENV;
  },
};

export const PAGE = {
  ROOT: () => "/",
  ACCREDITED_DENTAL_OFFICES: () => "/rede-credenciada",
  NOT_AUTHENTICATED: () => "/nao-autenticado",
  MENU: () => "/menu",
  HOME: (actionType: string) => `/seguros/${actionType}`,
  INITIAL_DATA: () => "/dados-iniciais",
  SPEAK_MANAGER: () => `${PAGE.INITIAL_DATA()}/fale-com-seu-gerente`,
  MODALITY: () => `${PAGE.INITIAL_DATA()}/modalidade`,
  OFFER: () => `${PAGE.MODALITY()}/ofertas`,
  SPOUSE_DATA: () => `${PAGE.OFFER()}/dados-do-conjuge`,
  DPS: () => `${PAGE.OFFER()}/DPS`,
  SELECT_QUESTIONS: () => `${PAGE.SPOUSE_DATA()}/selecionar-perguntas`,
  QUESTIONNARIE: () => `${PAGE.DPS()}/questionario`,
  COMPLEMENTARY_DATA_ONE: () => `${PAGE.DPS()}/dados-complementares-1-de-3`,
  COMPLEMENTARY_DATA_TWO: () => `${PAGE.DPS()}/dados-complementares-2-de-3`,
  COMPLEMENTARY_DATA_THREE: () => `${PAGE.DPS()}/dados-complementares-3-de-3`,
  BENEFICIARIES: () => `${PAGE.COMPLEMENTARY_DATA_THREE()}/beneficiarios`,
  PAYMENT: () => `${PAGE.BENEFICIARIES()}/pagamento`,
  RESUME: () => `${PAGE.PAYMENT()}/resumo`,
  TOKEN_VALIDATION: (contractType: string) => `/validacao/${contractType}`,
  CONTRACTED_INSURANCE: () => "/seguros-contratados",
  INSURANCE_DETAILS: () => `${PAGE.CONTRACTED_INSURANCE()}/detalhes`,
  USEFUL_PHONES: () => `${PAGE.INSURANCE_DETAILS()}/telefones-uteis`,
  CANCELLATION: () => `${PAGE.CONTRACTED_INSURANCE()}/cancelamento`,
  CANCELLATION_SUCCESS: () => `${PAGE.CANCELLATION()}/sucesso`,
  SUCCESS: () => "/sucesso",
  ERROR_DATE: () => "/data-errada",
  ERROR_AGE: () => "/data-invalida",
  ERROR_CELL_PHONE: () => "/telefone-invalido",
  ERROR_PROPOSAL: () => "/erro-na-proposta",
};

export const HOTJAR = {
  get HJID() {
    return window.env.ENV === "prd" ? 3923330 : undefined;
  },
  get HJSV() {
    return 6;
  },
};

export type AUTHCONFIG = {
  client_id: string;
  authority: string;
  redirect_uri: string;
  response_type: string;
  logout_uri: string;
  post_logout_redirect_uri: string;
  scope: string;
  silent_redirect_uri: string;
  automaticSilentRenew: boolean;
  loadUserInfo: boolean;
};

export const COVERAGE_TYPES = {
  COVERAGE: "COVERAGE",
  ASSISTANCE: "ASSISTANCE",
  SAF: "SAF",
  BENEFIT: "BENEFIT",
};

export const CATEGORY_TYPES = {
  RANGE: "RANGE",
  OPTION: "OPTION",
  DEFINED: "DEFINED",
};

export const KEY_TYPES = {
  [CATEGORY_TYPES.RANGE]: "range",
  [CATEGORY_TYPES.DEFINED]: "text",
  [CATEGORY_TYPES.OPTION]: "options",
};

export const UNITY_TYPE = {
  CURRENCY: "CURRENCY",
  PERCENT: "PERCENT",
  INTEGER: "INTEGER",
  TEXT: "TEXT",
  OPTION: "OPTION",
};

export const ERROR_DEFAULT = "Preencha esse campo para continuar";
export const NATURAL_DATE_FORMAT = "DD/MM/YYYY";
export const SERVER_DATE_FORMAT = "YYYY-MM-DD";
export const PAGE_TITLE = "Seguro Vida - Vida Mais Flex";
export const OFFER_BASE_PORCENTAGE = "35";
export const OFAGE = "A idade mínima para contratação do produto é 18 anos";
export const AGELIMIT =
  "Ainda não está disponível nenhum seguro para essa faixa etária";

export const PLANS = {
  VMF_SEM_DG_IND_MOBI: "VMF_SEM_DG_IND_MOBI",
  VMF_COM_DG_IND_MOBI: "VMF_COM_DG_IND_MOBI",
  VMF_COM_DG_MOBI: "VMF_COM_DG_MOBI",
  VMF_SEM_DG_MOBI: "VMF_SEM_DG_MOBI",
  VMF_AP_IND_MOBI: "VMF_AP_IND_MOBI",
  VMF_AP_FAM_MOBI: "VMF_AP_FAM_MOBI",
  VMF_AP_ENTRADAS: "VMF_AP_ENTRADAS",
};

export const HOLDER = "HOLDER";
export const CONJUGE = "CONJUGE";
export const SEGURO_VIDA = "SEGURO_VIDA";

export enum TAG_ACTION {
  Click = "Click",
  Screen = "Screen",
}

export enum TAG_PAGE {
  Onboarding = "Onboarding",
  Data_nascimento = "Data_nascimento",
  Protecoes = "Protecoes",
  Valor_protecao = "Valor_protecao",
  DPS = "DPS",
  Confirmacao_dados = "Confirmacao_dados",
  Profissao = "Profissao",
  Beneficiarios = "Beneficiarios",
  Pagamento = "Pagamento",
  Conferencia = "Conferencia",
  Erro_Proposta = "Erro_Proposta",
  Tela_token = "Tela_token",
  Proposta = "Proposta",
}

export enum TAG_TYPE {
  //Page: Home
  Avancar_onboarding = "Avancar_onboarding",
  Sair_onboarding = "Sair_onboarding",
  //Page: InitialData
  Alterar_data = "Alterar_data",
  Data_correta = "Data_correta",
  Sair_data_nascimento = "Sair_data_nascimento",
  //Page: Modality
  Select_protecao_completa = "Select_protecao_completa",
  Select_protecao_acidentes = "Select_protecao_acidentes",
  Sair_protecao = "Sair_protecao",
  //Page: Offer
  Saiba_mais_protecao = "Saiba_mais_protecao",
  Saiba_mais_dg = "Saiba_mais_dg",
  Saiba_mais_beneficios = "Saiba_mais_beneficios",
  Saiba_mais_saf = "Saiba_mais_saf",
  Sair_valor_protecao = "Sair_valor_protecao",
  Avancar_valor_protecao = "Avancar_valor_protecao",
  //Page: DPS
  Sair_dps = "Sair_dps",
  Avançar_dps = "Avançar_dps",
  //Page: ComplementaryData - One
  Sair_confirmacao_dados = "Sair_confirmacao_dados",
  editar_endereco = "editar_endereco",
  avancar_confirmacao_dados = "avancar_confirmacao_dados",
  //Page: ComplementaryData - Three
  Sair_profissao = "Sair_profissao",
  Select_profissao = "Select_profissao",
  //Page: Beneficiaries
  Sair_beneficiarios = "Sair_beneficiarios",
  Select_adicionar = "Select_adicionar",
  Avancar_beneficiario = "Avancar_beneficiario",
  //Page: Payment
  Sair_pagamento = "Sair_pagamento",
  Avancar_pagamento = "Avancar_pagamento",
  //Page: Resume
  Sair_conferencia = "Sair_conferencia",
  Assinar = "Assinar",
}

export const PAGE_TYPE = {
  [TAG_PAGE.Onboarding]: {
    Avancar_onboarding: TAG_TYPE.Avancar_onboarding,
    Sair_onboarding: TAG_TYPE.Sair_onboarding,
  },
  [TAG_PAGE.Data_nascimento]: {
    Alterar_data: TAG_TYPE.Alterar_data,
    Data_correta: TAG_TYPE.Data_correta,
    Sair_data_nascimento: TAG_TYPE.Sair_data_nascimento,
  },
  [TAG_PAGE.Protecoes]: {
    Select_protecao_completa: TAG_TYPE.Select_protecao_completa,
    Select_protecao_acidentes: TAG_TYPE.Select_protecao_acidentes,
    Sair_protecao: TAG_TYPE.Sair_protecao,
  },
  [TAG_PAGE.Valor_protecao]: {
    Saiba_mais_protecao: TAG_TYPE.Saiba_mais_protecao,
    Saiba_mais_dg: TAG_TYPE.Saiba_mais_dg,
    Saiba_mais_beneficios: TAG_TYPE.Saiba_mais_beneficios,
    Saiba_mais_saf: TAG_TYPE.Saiba_mais_saf,
    Sair_valor_protecao: TAG_TYPE.Sair_valor_protecao,
    Avancar_valor_protecao: TAG_TYPE.Avancar_valor_protecao,
  },
  [TAG_PAGE.DPS]: {
    Sair_dps: TAG_TYPE.Sair_dps,
    Avançar_dps: TAG_TYPE.Avançar_dps,
  },
  [TAG_PAGE.Confirmacao_dados]: {
    Sair_confirmacao_dados: TAG_TYPE.Sair_confirmacao_dados,
    editar_endereco: TAG_TYPE.editar_endereco,
    avancar_confirmacao_dados: TAG_TYPE.editar_endereco,
  },
  [TAG_PAGE.Profissao]: {
    Sair_profissao: TAG_TYPE.Sair_profissao,
    Select_profissao: TAG_TYPE.Select_profissao,
  },
  [TAG_PAGE.Beneficiarios]: {
    Sair_beneficiarios: TAG_TYPE.Sair_beneficiarios,
    Select_adicionar: TAG_TYPE.Select_adicionar,
    Avancar_beneficiario: TAG_TYPE.Avancar_beneficiario,
  },
  [TAG_PAGE.Pagamento]: {
    Sair_pagamento: TAG_TYPE.Sair_pagamento,
    Avancar_pagamento: TAG_TYPE.Avancar_pagamento,
  },
  [TAG_PAGE.Conferencia]: {
    Sair_conferencia: TAG_TYPE.Sair_conferencia,
    Assinar: TAG_TYPE.Assinar,
  },
};

export const DPS_STATUS = {
  inFilling: "inFilling",
  filled: "filled",
  notFilled: "notFilled",
};

export const DPS_STATUS_DESCRIPTION = {
  [DPS_STATUS.inFilling]: "Em preenchimento",
  [DPS_STATUS.filled]: "Preenchida",
  [DPS_STATUS.notFilled]: "Não preenchida",
};

export const EMAIL_REGEX = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,6}$/;

export const KINSHIP_DATA = [
  {
    value: "PARENT",
    label: "Mãe/Pai",
  },
  {
    value: "CHILD",
    label: "Filha/Filho",
  },
  {
    value: "SIBLING",
    label: "Irmã/Irmão",
  },
  {
    value: "SPOUSE",
    label: "Esposa/Esposo",
  },
  {
    value: "UNMARRIED_PARTNERS",
    label: "Companheira/Companheiro",
  },
  {
    value: "OTHER",
    label: "Outro",
  },
];

export const KINSHIP: DynamicObject<string> = {
  PARENT: "Mãe/Pai",
  CHILD: "Filha/Filho",
  SIBLING: "Irmã/Irmão",
  SPOUSE: "Esposa/Esposo",
  UNMARRIED_PARTNERS: "Companheira/Companheiro",
  OTHER: "Outro",
};

export const GATEWAY_URL =
  window.env?.ENV !== "prd"
    ? `https://insurance-gateway-web.${
        window?.env?.ENV ?? "dev"
      }.sicredi.cloud/seguros/simulacao`
    : "https://appseguros.sicredi.com.br/seguros/vitrine";

export const getBaseUrl = () => {
  if (window.location?.hostname === "localhost") {
    return `http://localhost:${window.location.port}`;
  }
  return window.env?.ENV !== "prd"
    ? `http://life-insurance-mobi-web.${
        window?.env?.ENV ?? "dev"
      }.sicredi.cloud`
    : "https://seguro-vida.app.sicredi.com.br";
};

const CLIENT_ID = "life-insurance-mobi-web";
const REDIRECT_PATH = "/dados-iniciais";

export const getAuthUrl = (env: string) => {
  if (env === "prd") {
    return "https://www.sicredi.com.br/autenticacao/cadastro";
  }
  return `https://authcorp-user.${env}.sicredi.cloud/autenticacao/cadastro`;
};

export const getCurrentEnv = () => {
  if (window.location?.hostname === "localhost") {
    return "dev";
  }
  return window?.env?.ENV ?? "dev";
};

export const GATEWAY_REGISTRATION = (() => {
  const env = getCurrentEnv();
  const baseUrl = getBaseUrl();
  const authUrl = getAuthUrl(env);

  const queryParams = new URLSearchParams({
    source_client_id: CLIENT_ID,
    source_redirect_uri: `${baseUrl}${REDIRECT_PATH}`,
  });

  return `${authUrl}?${queryParams.toString()}`;
})();
